var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('ErrorScene',{attrs:{"code":"404","description":"抱歉！您所访问的页面不存在，请返回当前平台重新进入。","primary-text":"返回登录页","primary-icon":"el-icon-house"},on:{"primary":_vm.goLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }